import { text } from "@fortawesome/fontawesome-svg-core";
import useGetColors from "../../utils/colors";
import t from "../../theme";

export const useGetOfferCardStyles = ({
  size,
  maxSize,
  height,
  maxHeight,
  mobile,
  isRedeemed,
  isSeen,
  itemType,
  validTo,
}) => {
  const { offerCardColors } = useGetColors();

  const defaultWidth = 240;
  const defaultHeight = 280;
  const cardSize = size || defaultWidth;
  const maxDimensions = maxSize || cardSize;

  const cardSize1 = height || defaultHeight;
  const maxDimensions1 = maxHeight || defaultHeight;

  const shouldDisableHover = isRedeemed || isSeen;

  // Calculate days remaining
  let cardFooterBgColor = t.brand.greenLight;
  let cardFooterTextColor = t.text.primary;
  if (validTo) {
    const now = new Date();
    const expiryDate = new Date(validTo);
    const daysRemaining = Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24));

    if (daysRemaining <= 1) {
      cardFooterBgColor = t.brand.redLight;
      cardFooterTextColor = t.text.primary;
    } else if (daysRemaining <= 3) {
      cardFooterBgColor = t.brand.yellow;
      cardFooterTextColor = t.text.primary;
    } else {
      cardFooterBgColor = t.brand.greenLight;
      cardFooterTextColor = t.text.primary;
    }
  }

  return {
    container: {
      backgroundColor: t.glass.primary,
      width: cardSize,
      borderRadius: 12,
      maxWidth: maxDimensions,
      border: t.border.base,
      boxShadow: t.shadow.sm,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      transition: t.transition.base,
      display: "flex",
      flexDirection: "column",
      flex: 1,
      "&:hover": shouldDisableHover
        ? {}
        : {
            boxShadow: t.shadow.md,
            transform: "translateY(-2px)",
            backgroundColor: t.glass.heavy,
          },
      position: "relative",
      overflow: "hidden",
      "@media (max-width: 425px)": {
        maxWidth: "100%",
      },
    },
    containerQueen: {},
    containerKing: {},
    wrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      cursor: "pointer",
      flex: 1,
    },
    cardHeaderWrapper: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      position: "absolute",
      top: "4px",
      padding: "6px 8px",
      background: t.glass.secondary,
      left: "4px",
      borderRadius: t.radius.sm,
      backdropFilter: t.blur.light,
      WebkitBackdropFilter: t.blur.light,
      boxShadow: "0 1px 3px " + t.border.colorBase,
      border: t.border.light,
    },
    favIcon: {
      padding: "4px",
      // background: "rgba(255, 255, 255, 1)",
      margin: "4px 2px",
      transition: "background 0.3s ease",
      // boxShadow: "1px 1px 4px #555",
      "&:hover": {
        background: "rgba(255, 255, 255, 0.3)",
      },
      "& svg": {
        fontSize: "1.5rem",
      },
    },
    offerTitleWrapper: {
      display: "flex",
      flexDirection: "column",
      padding: "0 10px",
      fontWeight: 500,
      flex: 1,
      width: "100%",
    },
    offerTitle: {
      color: t.text.primary,
      fontSize: "1rem",
      textTransform: "Capitalize",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      lineHeight: "1.3",
      marginBottom: "4px",
      fontWeight: 700,
    },
    offerSubText: {
      // position: "absolute",
      // right: "8px",
      // bottom: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "0",
      fontSize: "0.7rem",
      fontWeight: "500",
      padding: "0",
      borderRadius: "50px",
      background: "#dc3545",
      color: "#ffffff",
      boxShadow: "0 2px 8px rgba(220, 53, 69, 0.3)",
      width: "36px",
      minWidth: "36px",
      height: "36px",
      overflow: "hidden",
      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      cursor: "pointer",
      zIndex: 10,
      color: "#ffffff",
      "&:hover": {
        width: "auto",
        justifyContent: "flex-start",
        gap: "6px",
        paddingRight: "12px",
        paddingLeft: "10px",
      },
      "& > svg": {
        fontSize: "1.5rem",
        flexShrink: 0,
        color: "#ffffff",
      },
      "& .redeem-text": {
        fontSize: "0.7rem",
        fontWeight: "500",
        whiteSpace: "nowrap",
        opacity: 0,
        width: 0,
        transition: "opacity 0.2s ease, width 0.2s ease",
      },
      "& .amount": {
        fontSize: "1.1rem",
        fontWeight: "700",
        lineHeight: 1,
        whiteSpace: "nowrap",
        opacity: 0,
        width: 0,
        transition: "opacity 0.2s ease, width 0.2s ease",
      },
      "&:hover .redeem-text, &:hover .amount": {
        opacity: 1,
        width: "auto",
      },
    },
    cardFooterText: {
      fontSize: 18,
      color: offerCardColors.cardSubTextColor,
      cursor: "pointer",
    },
    mailTag: {
      color: "#ffffff",
      padding: "5px 12px",
      // width: "100%",
      textAlign: "center",
      letterSpacing: 2,
      fontSize: "0.7rem",
      fontWeight: "600",
      textTransform: "uppercase",
      borderRadius: "0 15px",
    },
    redeemTag: {
      background: t.red.gradient,
    },
    seenTag: {
      background: t.blue.gradient,
    },
    cardFooter: {
      marginTop: "auto",
      alignSelf: "flex-start",
      padding: "5px 12px",
      background: t.glass.heavy,
      backdropFilter: t.blur.light,
      WebkitBackdropFilter: t.blur.light,
      color: cardFooterTextColor,
      border: "none",
      display: "inline-flex",
      whiteSpace: "nowrap",
      alignItems: "center",
      gap: "4px",
      fontSize: "0.65rem",
      fontWeight: "600",
      letterSpacing: "0.3px",
      borderRadius: "0 15px",
      transition: "opacity 0.3s ease",
      zIndex: 5,
      boxShadow: "0 -2px 6px rgba(0,0,0,0.08), 2px 0 6px rgba(0,0,0,0.08)",
      "& > p": {
        fontSize: "0.65rem",
        fontWeight: "600",
        margin: 0,
      },
    },
    mailImage: {
      width: "100%",
      height: 140,
      overflow: "hidden",
      position: "relative",
      marginBottom: 8,
      background: t.glass.light,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0,
      "& img": {
        borderRadius: "12px 12px 0 0",
        transition: "transform 0.3s ease",
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      },
      "&:hover img": {
        transform: "scale(1.08)",
      },
    },
    mailWrapper: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
    },
    iconsWrapper: {
      // position: "absolute",
      // right: 9,
      // top: 9,
      textAlign: "right",
      zIndex: 1,
    },
    mailActions: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-end",
      padding: "0 0 0 0",
      "&.unseen": {
        background: "transparent",
      },
    },
    // mailState: {
    //   background: "linear-gradient(135deg, #00AEEF 0%, #0097d6 100%)",
    //   color: "#ffffff",
    //   padding: "8px 12px",
    //   width: "100%",
    //   textAlign: "center",
    //   letterSpacing: 2,
    //   fontSize: "1rem",
    //   fontWeight: "500",
    //   textTransform: "uppercase",
    //   display: "flex",
    //   alignItems: "center",
    //   justifyContent: "center",
    //   gap: "8px",
    // },
    mailMessage: {
      fontSize: "0.8rem",
      fontWeight: "300",
      color: offerCardColors.cardTitleColor,
      marginTop: "4px",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      lineHeight: "1.4",
      marginBottom: "0",
    },
    offerLike: {
      display: "flex",
      justifyContent: "space-between",
    },
    redeemedBg: {
      width: "100%",
      height: "auto",
      position: "absolute",
      opacity: 0.4,
      bottom: "-40%",
    },
  };
};
